import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { MeetingRepositoryImpl } from "../../data/repository/meeting_repository_impl";

export const useCheckMeetingExists = (meetingId: string | undefined) => {
    const repository = new MeetingRepositoryImpl();

    return useQuery<boolean, AxiosError>({
        queryKey: ['meetingExists', meetingId],
        queryFn: () => repository.checkMeetingExist(meetingId!),
        retry: 1,
        enabled: !!meetingId,
        staleTime: 10 * 60 * 1000,
        gcTime: 15 * 60 * 1000,
    });
};